import { Component, OnInit } from '@angular/core';
import { PermissionsService } from '../../services/permissions/permissions.service';
import { TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service';
import { AimsHub } from '../../../../src/app/components/aimsHub/aimsHub';
import { map } from 'rxjs/operators';

@Component({
  selector: 'scheduling',
  templateUrl: './scheduling.component.html',
  styleUrls: ['./scheduling.component.css'],
  providers: [AimsHub]
})

export class SchedulingComponent implements OnInit {

  constructor(public permissions: PermissionsService,
    private transferHttp: TransferHttpService,
    public countHub: AimsHub) {
  }

  count = this.countHub.getHot('schedulingCounts').pipe(map(countArr => countArr[0]));

  ngOnInit() {
  }

}
